export default __webpack_public_path__ + "static/media/img-top-speed-bg.ccda92f2.svg";